// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lfpnD0 {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: 100%;
  gap: var(--spacing-1);
}

.ekgpXK {
  text-align: left;
  margin: 0;
  width: 100%;
  display: flex;
  align-items: center;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  height: 25px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/HomeBanners/HomeBanners.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,YAAY;AACd","sourcesContent":[".homeBannersSection {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  width: 100%;\n  gap: var(--spacing-1);\n}\n\n.homeBannersTitle {\n  text-align: left;\n  margin: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  height: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeBannersSection": `lfpnD0`,
	"homeBannersTitle": `ekgpXK`
};
module.exports = ___CSS_LOADER_EXPORT___;
